
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

export default function slider () {
    Splide.defaults = {
        gap: '2rem',
        lazyLoad: 'sequential',
    };

    document.querySelectorAll('.splide-main')
        .forEach(elem => {
            if ( elem.closest('body.collection-landingpages') ) return;

            if (elem.querySelectorAll('.splide__slide').length > 1) {
                let thumbnails = null;
                let options = {};
                let thumbnailsSplide = null;

                if (elem.nextElementSibling?.classList.contains('splide-thumbnails')) {
                    options = {
                        pagination: false,
                    };

                    thumbnails = elem.nextElementSibling.querySelectorAll('.splide-thumbnails__thumbnail');
                }

                const splide = new Splide(elem, options);

                if (thumbnails) {
                    thumbnailsSplide = new Splide( '.splide-thumbnails', {
                        gap: 0,
                        pagination: false,
                        arrows: false,
                        isNavigation: true,
                        cloneStatus: false,
                    });

                    splide.sync(thumbnailsSplide);
                }

                splide.mount();

                if ( thumbnailsSplide ) {
                    thumbnailsSplide.mount();
                }
            }
        });
}
